import { ErrorCircle12Filled } from "@fluentui/react-icons";
import { useFieldErrorStyles } from "./FieldError.styles";
import { IFieldErrorProps } from "./FieldError.types";

export const FieldError = (props: IFieldErrorProps): JSX.Element => {
  const { message } = props;
  const styles = useFieldErrorStyles();

  return (
    <div className={styles.root} role="alert">
      <span className={styles.icon}>
        <ErrorCircle12Filled />
      </span>
      {message}
    </div>
  );
};
